(function () {
  const popup = document.querySelector('[data-newsletter-popup]');

  if (!popup) {
    return;
  }

  const storageKey = 'eliahNewsletterPopupDismissed';
  const dismissDuration = 7 * 24 * 60 * 60 * 1000;
  const success = popup.querySelector('#NewsletterPopup-success');
  const errors = popup.querySelector('#NewsletterPopup-error');
  const emailInput = popup.querySelector('#NewsletterPopupEmail');
  const closeButtons = popup.querySelectorAll('[data-newsletter-popup-close]');

  const getDismissedAt = function () {
    try {
      return Number(localStorage.getItem(storageKey) || 0);
    } catch (error) {
      return 0;
    }
  };

  const setDismissedAt = function () {
    try {
      localStorage.setItem(storageKey, String(Date.now()));
    } catch (error) {
      return;
    }
  };

  const openPopup = function () {
    popup.hidden = false;
    document.body.classList.add('newsletter-popup-open');

    if (emailInput && (success || errors)) {
      emailInput.focus();
    }
  };

  const closePopup = function () {
    popup.hidden = true;
    document.body.classList.remove('newsletter-popup-open');
    setDismissedAt();
  };

  closeButtons.forEach(function (button) {
    button.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !popup.hidden) {
      closePopup();
    }
  });

  if (success) {
    setDismissedAt();
    openPopup();
    return;
  }

  if (errors) {
    openPopup();
    return;
  }

  const dismissedAt = getDismissedAt();

  if (dismissedAt && Date.now() - dismissedAt < dismissDuration) {
    return;
  }

  window.setTimeout(openPopup, 1200);
})();
